<app-tabs-header [labelText]="'Search for a product by name OR code'"
                 [iconName]="'add'"
                 [showButton]="true"
                 [buttonText]="'Add Product'"
                 [navigateTo]="'/enterprise-management/add-product'"
                 (valueChanged)="onValueChanged($event)">
</app-tabs-header>

<div *ngIf="productsDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="productsDataSource"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container [matColumnDef]="TableColumns.Icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" matTooltip="EDIT Product"
                  (click)="editEntry($event, row)">
          edit
        </mat-icon>
        <mat-icon class="table-icon" matTooltip="DELETE Product"
                  (click)="onDeleteProductConfirmation($event, row)">
          delete
        </mat-icon>
        
        <app-duplicate tooltip="COPY Product"
                       (duplicateItem)="onDuplicateProductConfirmation($event, row)"></app-duplicate>
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.ProductId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.ProductId]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.Name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.Name]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.ProductCode">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Code</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.ProductCode]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.ProcessingClass">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Class</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.ProcessingClass]?.name}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.ProviderNetwork">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider Network</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.ProviderNetwork]?.name}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.Payer">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Payer</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.Payer]?.name}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.StartDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.StartDate] | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="TableColumns.EndDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
      <td *matCellDef="let row" mat-cell>{{row[TableColumns.EndDate] | date: dateFormat}}</td>
    </ng-container>
    
    
    <!-- Expanded Row -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="productsDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == productExpandedRow ? 'expanded' : 'collapsed'">
          
          <b>Approval Number: </b>{{row?.approvalNumber}}<br>
          <b>Claiming Days: </b>{{row?.claimingDays}}<br>
          <b>Booking Days: </b>{{row?.bookingDays}}<br>
          <b>Email Notification: </b>{{row?.emailNotification}}<br>
          <b>Reporting Class: </b>{{row.reportingClass?.name}}<br>
          <b>Regulator: </b>{{row.regulator?.name}}<br>
          <b>Currency: </b>{{row.currency?.name}}<br>
          <b>Area of Cover: </b>{{row.areaOfCover?.name}}<br>
          <b>Created By: </b>{{row?.createdBy}}<br>
          <b>Created Date: </b>{{row?.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row?.updatedBy}}<br>
          <b>Updated Date: </b>{{row?.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    
    <tr mat-header-row *matHeaderRowDef="productsDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: productsDisplayedColumns;"
        class="row" [class.expanded-row]="productExpandedRow == row"
        (click)="productExpandedRow = productExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>
  
  <mat-paginator #productPaginator (page)="pageChanged($event)"
                 [length]="productsTableControl.length" [pageSize]="productsTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="productsTableControl.pageSizeOptions">
  </mat-paginator>

</div>
